module.exports = __webpack_public_path__ + "static/media/logo_campuschile_y_ofimatica.0d6b2aa0.png";